import React from 'react'
import Navbar from './Navbar'

const Faqs = () => {
    return (
        <div>
            <Navbar />
        </div>
    )
}

export default Faqs